import { render, staticRenderFns } from "./shenheRecord.vue?vue&type=template&id=4a4a0232&scoped=true"
import script from "./shenheRecord.vue?vue&type=script&lang=js"
export * from "./shenheRecord.vue?vue&type=script&lang=js"
import style0 from "./shenheRecord.vue?vue&type=style&index=0&id=4a4a0232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4a0232",
  null
  
)

export default component.exports